var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hardness())?_c('v-chip',{staticClass:"pl-1 pr-2",attrs:{"small":"","outlined":""}},[_c('strong',{staticClass:"pl-1"},[_vm._v("\n    "+_vm._s(_vm.label())+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }